/* eslint-env jquery */
import form from "./_form.js";

function getRowsWithCheckboxes() {
  return form.getFormRows().filter(".checkboxes");
}

function getCheckboxes() {
  return getRowsWithCheckboxes().find("input.checkbox");
}

function addCheckboxClickHandler() {
  getCheckboxes().off("click");
  getCheckboxes().on("click", function (event) {
    const $checkbox = $(event.currentTarget);
    const $row = $checkbox.parents(".form-row");
    $row.toggleClass("showguide", $checkbox.is(":checked"));
  });
}

export default { getRowsWithCheckboxes, getCheckboxes, addCheckboxClickHandler };
